const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/LinksBlock.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import { LinkFrame } from 'App/components/old_components/components/LinkFrame';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import textMap from '../../translations';
import { MessageDescriptor } from '@formatjs/intl';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { actionSetInCIS4mDataObject } from '@cistec/common_web/modules/CIS4m/actions';
import Divider from '@mui/material/Divider';
import { useDispatch } from 'react-redux';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';

export interface Link {
    name: string;
    text: MessageDescriptor;
    href: string;
}

interface Props {
    hidden?: boolean;
    label?: TextInput;
    hideCheckbox?: boolean;
    links: Link[];
    required?: boolean;
    basePath: string;
}

export const LinksBlock = forwardRef((props: Props, ref: any) => {
    const label = useText(props.label ?? textMap.iConfirm);
    const required = props.required ?? false;
    const hideCheckbox = props.hideCheckbox ?? false;
    const PATH_CHECKBOX = createFieldPath(props.basePath, 'linksChecked');

    const { formId } = useCIS4mContext();
    const dispatch = useDispatch<any>();

    const { links } = props;

    const linksBlockRef = useCIS4m(ref, undefined, () => {
        links.forEach(link => {
            const path = createFieldPath(props.basePath, link.name);
            dispatch(actionSetInCIS4mDataObject(formId, path, '1'));
        });
    });

    const hidden = props.hidden ?? false;

    const rows = links.map(link => <LinkFrame key={link.href} text={link.text} href={link.href} />);

    return (
        <CIS4mBlock ref={linksBlockRef} hidden={hidden}>
            <div>{rows}</div>
            {!hideCheckbox && (
                <CIS4mBlock>
                    <Divider />
                    <CIS4mSingleCheckbox label={label} required={required} path={PATH_CHECKBOX} />
                </CIS4mBlock>
            )}
        </CIS4mBlock>
    );
});

LinksBlock.displayName = 'LinksBlock';
